import { Component , HostBinding } from '@angular/core';
import { HeaderComponent } from '../shared/header.component';
import { FooterComponent } from '../shared/footer.component';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.css'],
  standalone: true,
  imports: [HeaderComponent,FooterComponent, RouterModule]
})
export class TermsComponent {

  @HostBinding('style.width') public readonly WIDTH = '100%';

  title = 'webapp';
  scrollToElement($element: any): void {
    $element.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
  }
}


